<div class="error-page">
    <h2>Errors:</h2>
    <p>{{ errorMessage }}</p>
  </div>